import { render, staticRenderFns } from "./RequestProductDialog.vue?vue&type=template&id=5627e44c&scoped=true"
import script from "./RequestProductDialog.vue?vue&type=script&lang=js"
export * from "./RequestProductDialog.vue?vue&type=script&lang=js"
import style0 from "./RequestProductDialog.vue?vue&type=style&index=0&id=5627e44c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5627e44c",
  null
  
)

export default component.exports